
export default {
  name: 'Footer',
}
